/* unplugin-vue-components disabled */import script from "./NotificationPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationPanel.vue?vue&type=script&setup=true&lang=js"

import "./NotificationPanel.vue?vue&type=style&index=0&id=0a0f2132&lang=scss&scoped=true"

import exportComponent from "../../../../../Users/mac/myproject/deepsage/deepsage_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a0f2132"]])

export default __exports__